import { cn } from "@newxsystems/shared";
import type { IBackgroundContainerBlockProps } from "./BackgroundContainerBlock.props";

const backgrounds: Record<string, string> = {
  canvas: "sprout-background-mineral",
  paper: "sprout-background-mineral",
  mint: "bg-primary text-primary-foreground",
  blue: "sprout-background-basalt",
  violet: "sprout-background-ink",
  dots: "sprout-background-mineral",
};

export const BackgroundContainerBlock = ({
  background,
  components,
  parentClass,
}: IBackgroundContainerBlockProps) => {
  if (!components) return null;

  return (
    <div
      className={cn(background ? backgrounds[background] : backgrounds.canvas, parentClass)}
      data-background={background || "canvas"}
      data-background-container=""
    >
      {components}
    </div>
  );
};

BackgroundContainerBlock.displayName = "Block::BackgroundContainerBlock";
